<div style="max-width:1080px;margin:0 auto;padding:28px 22px 80px;font-family:Inter,system-ui,sans-serif;color:#1B2F4E">

  <div style="display:flex;align-items:center;justify-content:space-between;border-bottom:1px solid #E2E6EE;padding-bottom:16px">
    <div>
      <h1 style="margin:0;font-size:24px">The Energy Professor — Admin</h1>
      <p style="margin:4px 0 0;color:#5A6373;font-size:14px">Manage the report library and the services. Changes go straight to the API.</p>
    </div>
    <div style="display:flex;align-items:center;gap:10px">
      <input type="password" [(ngModel)]="adminToken" [ngModelOptions]="{standalone:true}" placeholder="Admin token" style="padding:8px 10px;border:1px solid #E2E6EE;border-radius:4px;font-size:13px">
      <button class="btn ghost" (click)="applyToken()">Use token</button>
      <a routerLink="/" class="btn ghost">View the site</a>
    </div>
  </div>

  <p *ngIf="notice" style="background:#eef6ee;border:1px solid #cfe3cf;color:#1f5132;padding:10px 14px;border-radius:4px;margin:18px 0">{{ notice }}</p>
  <p *ngIf="error" style="background:#fdeef0;border:1px solid #f1c9cf;color:#B91E32;padding:10px 14px;border-radius:4px;margin:18px 0">{{ error }}</p>

  <!-- ===================== ACTIVITY ===================== -->
  <section *ngIf="activity" style="margin-top:30px">
    <div style="display:flex;align-items:center;justify-content:space-between">
      <h2 style="font-size:18px;margin:0">Activity</h2>
      <button class="btn ghost" (click)="loadActivity()">Refresh</button>
    </div>
    <div style="display:grid;grid-template-columns:repeat(3,1fr);gap:14px;margin-top:14px">
      <div style="background:#F5F5F5;border-radius:6px;padding:16px">
        <div style="font-size:30px;font-weight:800">{{ activity.totalSubmissions }}</div>
        <div style="color:#5A6373;font-size:13px">Requests submitted</div>
      </div>
      <div style="background:#F5F5F5;border-radius:6px;padding:16px">
        <div style="font-size:30px;font-weight:800">{{ activity.totalDownloads }}</div>
        <div style="color:#5A6373;font-size:13px">Report downloads</div>
      </div>
      <div style="background:#F5F5F5;border-radius:6px;padding:16px">
        <div style="font-size:30px;font-weight:800">{{ activity.totalServiceInterest }}</div>
        <div style="color:#5A6373;font-size:13px">Service interest</div>
      </div>
    </div>
    <div style="display:grid;grid-template-columns:1fr 1fr;gap:24px;margin-top:18px">
      <div>
        <h3 style="font-size:14px;color:#5A6373;margin:0 0 8px">Reports requested</h3>
        <p *ngIf="!activity.byReport.length" style="color:#5A6373;font-size:13px">No report activity yet.</p>
        <div *ngFor="let t of activity.byReport" style="display:flex;justify-content:space-between;border-bottom:1px solid #E2E6EE;padding:6px 0;font-size:14px">
          <span>{{ t.key }}</span><strong>{{ t.count }}</strong>
        </div>
      </div>
      <div>
        <h3 style="font-size:14px;color:#5A6373;margin:0 0 8px">Service interest</h3>
        <p *ngIf="!activity.byService.length" style="color:#5A6373;font-size:13px">No service activity yet.</p>
        <div *ngFor="let t of activity.byService" style="display:flex;justify-content:space-between;border-bottom:1px solid #E2E6EE;padding:6px 0;font-size:14px">
          <span>{{ t.key }}</span><strong>{{ t.count }}</strong>
        </div>
      </div>
    </div>
    <p style="color:#5A6373;font-size:12px;margin-top:14px">{{ activity.note }}</p>
  </section>

  <!-- ===================== REPORTS ===================== -->
  <section style="margin-top:30px">
    <div style="display:flex;align-items:center;justify-content:space-between">
      <h2 style="font-size:18px;margin:0">Reports</h2>
      <button class="btn" (click)="newReport()">Add report</button>
    </div>

    <table style="width:100%;border-collapse:collapse;margin-top:14px;font-size:14px">
      <thead>
        <tr style="text-align:left;border-bottom:2px solid #E2E6EE;color:#5A6373">
          <th style="padding:8px 6px;width:70px">Order</th>
          <th style="padding:8px 6px">Title</th>
          <th style="padding:8px 6px;width:120px">Status</th>
          <th style="padding:8px 6px;width:80px">Featured</th>
          <th style="padding:8px 6px;width:320px">Actions</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let r of reports; let i = index" style="border-bottom:1px solid #EEF1F6">
          <td style="padding:8px 6px">
            <button (click)="moveReport(i,-1)" [disabled]="i===0" title="Move up">&#8593;</button>
            <button (click)="moveReport(i,1)" [disabled]="i===reports.length-1" title="Move down">&#8595;</button>
          </td>
          <td style="padding:8px 6px"><strong>{{ r.title }}</strong><br><span style="color:#9aa3b2;font-size:12px">{{ r.slug }}</span></td>
          <td style="padding:8px 6px">{{ r.status }}</td>
          <td style="padding:8px 6px">{{ r.featured ? 'yes' : '' }}</td>
          <td style="padding:8px 6px;display:flex;gap:6px;flex-wrap:wrap">
            <button (click)="editReport(r)">Edit</button>
            <button (click)="publish(r)" *ngIf="r.status !== 'available'">Publish</button>
            <button (click)="retire(r)" *ngIf="r.status !== 'retired'">Retire</button>
          </td>
        </tr>
      </tbody>
    </table>

    <!-- report editor -->
    <div *ngIf="editingReport as r" style="margin-top:18px;border:1px solid #E2E6EE;border-radius:6px;padding:18px;background:#fafbfd">
      <h3 style="margin:0 0 12px">{{ r.slug ? 'Edit report' : 'New report' }}</h3>
	  <div style="display:grid;grid-template-columns:1fr 1fr;gap:12px">
		  <label>Slug<input [(ngModel)]="r.slug" [ngModelOptions]="{standalone:true}" placeholder="national-utility-landscape" style="width:100%"></label>
		  <label>Title<input [(ngModel)]="r.title" [ngModelOptions]="{standalone:true}" style="width:100%"></label>
		  <label>Descriptor<input [(ngModel)]="r.descriptor" [ngModelOptions]="{standalone:true}" style="width:100%"></label>
		  <label>Tagline<input [(ngModel)]="r.tagline" [ngModelOptions]="{standalone:true}" style="width:100%"></label>
		  <label>
			  Status
			  <select [(ngModel)]="r.status" [ngModelOptions]="{standalone:true}" style="width:100%">
				  <option *ngFor="let s of reportStatuses" [value]="s">{{ s }}</option>
			  </select>
		  </label>
		  <label>Order<input type="number" [(ngModel)]="r.order" [ngModelOptions]="{standalone:true}" style="width:100%"></label>
		  <label>Cover image path<input [(ngModel)]="r.coverImage" [ngModelOptions]="{standalone:true}" placeholder="assets/covers/...-web.jpg" style="width:100%"></label>
		  <label>Thumbnail path<input [(ngModel)]="r.thumbnailImage" [ngModelOptions]="{standalone:true}" placeholder="assets/thumbs/...-thumb.jpg" style="width:100%"></label>
		  <label>File path<input [(ngModel)]="r.file" [ngModelOptions]="{standalone:true}" placeholder="assets/reports/....pdf" style="width:100%"></label>
		  <label>Version<input [(ngModel)]="r.version" [ngModelOptions]="{standalone:true}" placeholder="1.0" style="width:100%"></label>
		  <label style="grid-column:1 / -1;display:flex;align-items:center;gap:8px"><input type="checkbox" [(ngModel)]="r.featured" [ngModelOptions]="{standalone:true}"> Featured in the banner</label>
		  <label style="grid-column:1 / -1">
			  Findings, one per line
			  <textarea rows="4" [ngModel]="(r.findings || []).join('\n')" (ngModelChange)="r.findings = splitLines($event)" [ngModelOptions]="{standalone:true}" style="width:100%"></textarea>
		  </label>
	  </div>
      <div style="margin-top:12px;display:flex;gap:8px">
        <button class="btn" (click)="saveReport()">Save</button>
        <button class="btn ghost" (click)="cancelReport()">Cancel</button>
      </div>
      <p style="color:#5A6373;font-size:13px;margin-top:10px">Publish becomes available once the file, cover and thumbnail are set. That is the safe way to take a report live.</p>
    </div>
  </section>

  <!-- ===================== SERVICES ===================== -->
  <section style="margin-top:44px">
    <div style="display:flex;align-items:center;justify-content:space-between">
      <h2 style="font-size:18px;margin:0">Services</h2>
      <button class="btn" (click)="newService()">Add service</button>
    </div>

    <table style="width:100%;border-collapse:collapse;margin-top:14px;font-size:14px">
      <thead>
        <tr style="text-align:left;border-bottom:2px solid #E2E6EE;color:#5A6373">
          <th style="padding:8px 6px;width:70px">Order</th>
          <th style="padding:8px 6px">Name</th>
          <th style="padding:8px 6px;width:130px">Group</th>
          <th style="padding:8px 6px;width:90px">Status</th>
          <th style="padding:8px 6px;width:220px">Actions</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let s of services; let i = index" style="border-bottom:1px solid #EEF1F6">
          <td style="padding:8px 6px">
            <button (click)="moveService(i,-1)" [disabled]="i===0" title="Move up">&#8593;</button>
            <button (click)="moveService(i,1)" [disabled]="i===services.length-1" title="Move down">&#8595;</button>
          </td>
          <td style="padding:8px 6px"><strong>{{ s.name }}</strong><br><span style="color:#9aa3b2;font-size:12px">{{ s.slug }}</span></td>
          <td style="padding:8px 6px">{{ s.group }}</td>
          <td style="padding:8px 6px">{{ s.status }}</td>
          <td style="padding:8px 6px;display:flex;gap:6px;flex-wrap:wrap">
            <button (click)="editService(s)">Edit</button>
            <button (click)="toggleService(s)">{{ s.status === 'active' ? 'Hide' : 'Show' }}</button>
          </td>
        </tr>
      </tbody>
    </table>

    <!-- service editor -->
    <div *ngIf="editingService as s" style="margin-top:18px;border:1px solid #E2E6EE;border-radius:6px;padding:18px;background:#fafbfd">
      <h3 style="margin:0 0 12px">{{ s.slug ? 'Edit service' : 'New service' }}</h3>
      <div style="display:grid;grid-template-columns:1fr 1fr;gap:12px">
        <label>Slug<input [(ngModel)]="s.slug" [ngModelOptions]="{standalone:true}" style="width:100%"></label>
        <label>Name<input [(ngModel)]="s.name" [ngModelOptions]="{standalone:true}" style="width:100%"></label>
        <label>Group
          <select [(ngModel)]="s.group" [ngModelOptions]="{standalone:true}" style="width:100%">
            <option *ngFor="let g of groups" [value]="g">{{ g }}</option>
          </select>
        </label>
        <label>Order<input type="number" [(ngModel)]="s.order" [ngModelOptions]="{standalone:true}" style="width:100%"></label>
        <label>Stripe link<input [(ngModel)]="s.stripeLink" [ngModelOptions]="{standalone:true}" placeholder="https://buy.stripe.com/..." style="width:100%"></label>
        <label>Call to action<input [(ngModel)]="s.cta" [ngModelOptions]="{standalone:true}" placeholder="Commission an assessment" style="width:100%"></label>
        <label style="display:flex;align-items:center;gap:8px;margin-top:22px"><input type="checkbox" [(ngModel)]="s.planningSession" [ngModelOptions]="{standalone:true}"> Offers a planning session</label>
        <label style="grid-column:1 / -1">Description
          <textarea rows="3" [(ngModel)]="s.description" [ngModelOptions]="{standalone:true}" style="width:100%"></textarea>
        </label>
      </div>
      <div style="margin-top:12px;display:flex;gap:8px">
        <button class="btn" (click)="saveService()">Save</button>
        <button class="btn ghost" (click)="cancelService()">Cancel</button>
      </div>
    </div>
  </section>
  <!-- ===================== GLOSSARY ===================== -->
  <section style="margin-top:44px">
    <h2 style="font-size:18px;margin:0">Glossary surfacing</h2>
    <p style="margin:4px 0 0;color:#5A6373;font-size:14px">Paste any copy. The tool surfaces the glossary terms inside it and links each one to its page on the glossary. Wired directly to the glossary master.</p>

    <div style="margin-top:14px">
      <textarea rows="6" [(ngModel)]="glossaryInput" [ngModelOptions]="{standalone:true}" placeholder="Paste a report summary, a card description or any copy..." style="width:100%;font-family:Inter,sans-serif;font-size:14px;padding:10px;border:1px solid #E2E6EE;border-radius:4px"></textarea>
      <div style="display:flex;align-items:center;gap:14px;margin-top:10px">
        <button class="btn" (click)="surfaceTerms()" [disabled]="glossaryBusy">{{ glossaryBusy ? 'Working...' : 'Surface terms' }}</button>
        <button class="btn ghost" (click)="clearGlossary()">Clear</button>
        <label style="display:flex;align-items:center;gap:8px;font-size:13px;color:#5A6373"><input type="checkbox" [(ngModel)]="glossaryFirstOnly" [ngModelOptions]="{standalone:true}"> Link first mention only</label>
      </div>
    </div>

    <div *ngIf="glossaryHtml" style="margin-top:18px">
      <h3 style="font-size:14px;color:#5A6373;margin:0 0 8px">Linked preview</h3>
      <div style="background:#fff;border:1px solid #E2E6EE;border-radius:6px;padding:16px;line-height:1.6;font-size:15px" [innerHTML]="glossaryHtml"></div>
      <h3 style="font-size:14px;color:#5A6373;margin:18px 0 8px">{{ glossaryMatches.length }} terms surfaced</h3>
      <div style="display:flex;flex-wrap:wrap;gap:8px">
        <a *ngFor="let m of glossaryMatches" [href]="m.url" target="_blank" rel="noopener" style="font-size:13px;background:#F5F5F5;border:1px solid #E2E6EE;border-radius:20px;padding:5px 12px;color:#1B2F4E;text-decoration:none">{{ m.term }} <span style="color:#5A6373">&times;{{ m.count }}</span></a>
      </div>
    </div>
  </section>

</div>
